module.exports = __webpack_public_path__ + "img/ideal.57799a35.svg";